<template>
	<div class="app">

		<img class="top-bg" src="../../assets/lianxi/bg.png">

		<div class="neirong">
			<div class="title">
				<div class="a">联系我们</div>
				<div class="b">如果有任何疑问请联系我们，我们将竭诚为您服务</div>
			</div>
			<div class="lianxi-ul">
				<div class="li">
					<img class="img" src="../../assets/lianxi/1.png">
					<div class="text">
						<div class="a">联系电话：</div>
						<div class="b">修改电话信息</div>
					</div>
				</div>
				<div class="li">
					<img class="img" src="../../assets/lianxi/2.png">
					<div class="text">
						<div class="a">商务合作：</div>
						<div class="b">修改合作信息</div>
					</div>
				</div>
				<div class="li">
					<img class="img" src="../../assets/lianxi/3.png">
					<div class="text">
						<div class="a">公司邮箱：</div>
						<div class="b">修改邮箱信息</div>
					</div>
				</div>
			</div>
		</div>

		<div class="dibu-info">
			<img class="bg" src="../../assets/lianxi/bg2.png">
			<div class="neirong">
				<div class="left">
					<div class="dizhi-title">公司名称：</div>
					<div class="dizhi-text">修改名称信息</div>
				</div>
			</div>
			<div class="neirong">
				<div class="left">
					<div class="dizhi-title">公司地址：</div>
					<div class="dizhi-text">修改地址信息</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		comImage,
		comDetails
	} from "@/api/user";
	export default {
		data() {
			return {}
		},
		mounted() {},
		methods: {}
	};
</script>

<style scoped lang="less">
	.app {
		width: 100%;
		min-height: calc(100vh - 300px);
		background-color: #FFF;
	}

	.top-bg {
		width: 100%;
	}

	.neirong {
		width: 1300px;
		position: relative;
		margin: 0 auto;

		.title {
			width: 100%;
			text-align: center;
			padding: 40px 0 20px;

			.a {
				font-size: 28px;
				font-family: PingFang SC;
				font-weight: bold;
				color: #333333;
			}

			.b {
				font-size: 18px;
				font-family: PingFang SC;
				font-weight: 500;
				color: #777777;
				padding-top: 20px;
			}
		}

		.lianxi-ul {
			display: flex;
			justify-content: space-between;
			padding: 20px 0 50px 0;

			.li {
				display: flex;
				align-items: center;
				background: #FFFFFF;
				box-shadow: 0px 3px 17px 2px rgba(255, 32, 33, 0.14);
				border-radius: 5px;
				padding: 15px 40px;

				width: 280px;

				.img {
					height: 30px;
				}

				.text {
					margin-left: 20px;

					.a {
						font-size: 20px;
						font-weight: bold;
						color: #333333;
					}

					.b {
						font-size: 18px;
						color: #333333;
						padding-top: 10px;
						word-wrap: break-word;
						word-break: break-all;
					}
				}
			}
		}
	}

	.dibu-info {
		position: relative;
		width: 100%;
		height: 400px;

		.bg {
			width: 100%;
			height: 400px;
			position: absolute;
			top: 0;
			left: 0;
		}

		.neirong {
			display: flex;
			align-items: center;
			justify-content: space-between;

			.left {
				width: 100%;
				margin-top: 40px;

				.dizhi-title {
					font-size: 22px;
					font-family: PingFang SC;
					font-weight: bold;
					color: #333333;
				}

				.dizhi-text {
					font-size: 18px;
					color: #333333;
					margin-top: 10px;
					word-wrap: break-word;
				}
			}

			.right {
				display: flex;
				text-align: center;

				.li {
					margin-left: 40px;

					.img {
						width: 210px;
						height: 210px;
						background: #FFFFFF;
					}

					.text {
						font-size: 18px;
						font-family: PingFang SC;
						font-weight: bold;
						color: #333333;
						margin-top: 10px;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/lianxi/lianxi.vue